import { render, staticRenderFns } from "./TicketingSettings.vue?vue&type=template&id=7d7c5eaa&scoped=true"
import script from "./TicketingSettings.vue?vue&type=script&lang=js"
export * from "./TicketingSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7c5eaa",
  null
  
)

export default component.exports